function formatNumbers(value: number): string {
  return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function updateContent(el: HTMLElement) {
  const number = parseFloat(el.innerText)

  if (isNaN(number)) {
    return
  }

  const formattedNumber = formatNumbers(number)
  const [integerPart, decimalPart] = formattedNumber.split('.')

  el.innerHTML = `<span class="f-amount b-amount">${integerPart}.</span><span class="f-small-amount">${decimalPart}</span>`
}

export default {
  mounted(el: HTMLElement) {
    updateContent(el)
  },
  updated(el: HTMLElement) {
    updateContent(el)
  },
}
